export default {
  paged: {
    select: 'id,status,processInstanceName,processInstanceId,actionInstanceId,created',
    searchSelect: [
      'delegatedUser/fullName',
      'process/name',
      'environment/name',
      'processInstanceName',
    ],
    notSelectSearch:
      'delegatedUser,process,environment,actionInstance,processInstance,status,actionInstanceId,created',
    expand: {
      delegatedUser: { select: 'id,fullName' },
      processInstance: { select: 'id,name' },
      actionInstance: { select: 'status' },
      process: { select: 'name' },
      environment: { select: 'name' },
    },
  },
};
